import { find } from 'lodash'

export function getChallengeById(challenges, challengeId) {
  return find(challenges, c => c.challengeId === challengeId)
}



// WEBPACK FOOTER //
// ./src/services/challengesUtils.js